import axios from 'axios'
// import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
const router = useRouter()
// const store = useStore()
import { ElMessage } from 'element-plus'

const toLogin = () => {
    router.push({
        name: 'login',
        query: {
            redirect: router.currentRoute.value.path !== '/login' ? router.currentRoute.value.fullPath : undefined
        }
    })
}
// 是否开启代理
const isProxy = false
// 域名
const baseURL = 'http://61.171.99.107:8010/'
// 开发环境下，开启代理，生产环境下，不开启代理
const api = axios.create({
    baseURL: isProxy ? '/proxy/' : baseURL,
    timeout: 10000,
    responseType: 'json'
})

api.interceptors.request.use(
    request => {
        /**
         *
         * 全局拦截请求发送前提交的参数
         * 以下代码为示例，在请求头里带上 token 信息
         */
        // request.headers['TENANT-ID'] = import.meta.env.VITE_APP_DEBUG_TENANT
        return request
    }
)

api.interceptors.response.use(
    response => {
        /**
         * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
         * 假设返回数据格式为：{ status: 1, error: '', data: '' }
         * 规则是当 status 为 1 时表示请求成功，为 0 时表示接口需要登录或者登录状态失效，需要重新登录
         * 请求出错时 error 会返回错误信息
         */
        if (response.data && response.status != 424) {
        //     if (response.data.access_token || response.data.code == 0 || response.data.status == 1) {
        //         // 请求成功并且没有报错
                return Promise.resolve(response.data)
        //     } else {
        //         // 这里做错误提示
        //         if (response.data.code == 401 || response.status == 401) {
        //             store.state.user.token = ''
        //             toLogin()
        //         } else {
        //             return Promise.resolve(response.data)
        //         }
        //     }
        // } else {
        //     store.state.user.token = ''
        //     toLogin()
        }
    },
    error => {
        let message = error.message
        let msg = '请求失败'
        if (message.includes('424') || message.includes('401')) {
            message = '令牌过期请重新登录'
            localStorage.removeItem('token')
            toLogin()
        } else if (message.includes('timeout')) {
            message = '接口请求超时' 
        } else if (message.includes('Network Error')) {
            message = '后端网络故障'
        } else if (message.includes('404')) {
            message = '请求地址错误'
        }
        ElMessage({
            message: msg,
            type: 'error'
        })
        return Promise.reject(error)
    }
)

export default api
